import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import withStyles from '@material-ui/core/styles/withStyles';
import * as constants from '../../../constants'
import { WID } from '../../../constants/Language';
import Word from '../../../containers/Common/Word'

const styles = theme => ({
  list: {
    marginBottom: '20px',
  },
  listItemGameInfo: {
    marginLeft: theme.spacing.unit * 2,
  }
});

class SettingsDialog extends React.Component {  
  render() {
    const {
      fullScreen,
      classes,
      open,
      editMode,
      settings,
      handleEnter,
      handleClose,
      handleOK,
      handleChangeCheckbox,
    } = this.props
    
    const {
      isVisibleNumber,
      isVisibleForbidden,
      isVisibleCoordinate,
      isVisibleNextMove,
      isVisibleLastMoveMark,
      isVisibleGameInfo,
      isVisibleTitle,
      isVisiblePlayerName,
      isVisibleGameResult,
    } = settings

    return (
      <Dialog fullScreen={fullScreen} open={open} onEnter={handleEnter} onClose={handleClose}>
        <DialogTitle id="settings-dialog-title">
          <Word wid={WID.SETTINGS_DIALOG.DIALOG_TITLE}/>
        </DialogTitle>
        <DialogContent>
          <Typography><Word wid={WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.SUBTITLE}/></Typography>
          <List className={classes.list}>
            <ListItem>
              <ListItemText><Word wid={WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.COORDINATE}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  checked={isVisibleCoordinate}
                  onChange={handleChangeCheckbox('isVisibleCoordinate')}
                  value="isVisibleCoordinate"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemText><Word wid={WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.NUMBER_OF_MOVE}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  checked={isVisibleNumber}
                  onChange={handleChangeCheckbox('isVisibleNumber')}
                  value="isVisibleNumber"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemText><Word wid={WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.FORBIDDEN}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  checked={isVisibleForbidden}
                  onChange={handleChangeCheckbox('isVisibleForbidden')}
                  value="isVisibleForbidden"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemText><Word wid={WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.NEXT_MOVE_MARK}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  checked={isVisibleNextMove}
                  onChange={handleChangeCheckbox('isVisibleNextMove')}
                  value="isVisibleNextMove"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemText><Word wid={WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.LAST_MOVE_MARK}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  checked={isVisibleLastMoveMark}
                  onChange={handleChangeCheckbox('isVisibleLastMoveMark')}
                  value="isVisibleLastMoveMark"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            {editMode === constants.editModeType.NORMAL && (
            <React.Fragment>
            <ListItem style={{minWidth: '250px'}}>
              <ListItemText><Word wid={WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.SUBTITLE}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  checked={isVisibleGameInfo}
                  onChange={handleChangeCheckbox('isVisibleGameInfo')}
                  value="isVisibleGameInfo"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem disabled={!isVisibleGameInfo} className={classes.listItemGameInfo}>
              <ListItemText disableTypography={!isVisibleGameInfo}><Word wid={WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.TITLE}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  disabled={!isVisibleGameInfo}
                  checked={isVisibleTitle}
                  onChange={handleChangeCheckbox('isVisibleTitle')}
                  value="isVisibleTitle"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem disabled={!isVisibleGameInfo} className={classes.listItemGameInfo}>
              <ListItemText disableTypography={!isVisibleGameInfo}><Word wid={WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.PLAYER_NAME}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  disabled={!isVisibleGameInfo}
                  checked={isVisiblePlayerName}
                  onChange={handleChangeCheckbox('isVisiblePlayerName')}
                  value="isVisiblePlayerName"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem disabled={!isVisibleGameInfo} className={classes.listItemGameInfo}>
              <ListItemText disableTypography={!isVisibleGameInfo}><Word wid={WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.GAME_RESULT}/></ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  disabled={!isVisibleGameInfo}
                  checked={isVisibleGameResult}
                  onChange={handleChangeCheckbox('isVisibleGameResult')}
                  value="isVisibleGameResult"
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
            </React.Fragment>
            )}            
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
              Cancel
          </Button>
          <Button onClick={handleOK(settings)} color="primary" autoFocus>
              OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(SettingsDialog));


// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/SettingsDialog.js